/* eslint-disable
    @typescript-eslint/no-this-alias,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Board } from 'app/scripts/models/board';
import { Card } from 'app/scripts/models/card';
import { getKey, Key } from '@trello/keybindings';
import limitExceededTemplate from 'app/scripts/views/templates/popover_limit_exceeded';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { parseTrelloUrl } from 'app/scripts/lib/util/url/parse-trello-url';
import Payloads from 'app/scripts/network/payloads';
import Promise from 'bluebird';
import { Recents } from 'app/scripts/lib/recents';
import { Util } from 'app/scripts/lib/util';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import selectBoardTemplate from 'app/scripts/views/templates/select_board';
import selectCardTemplate from 'app/scripts/views/templates/select_card';
import template from 'app/scripts/views/templates/popover_trello_completer';
import { Analytics } from '@trello/atlassian-analytics';
import { ApiError } from '@trello/error-handling';
import { isShortId } from '@trello/shortlinks';
import { getRecentBoards } from '@trello/recent-boards';

class TrelloCompleterView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'add card or board';

    this.prototype.events = {
      'mouseenter .js-select-card,.js-select-board': 'hoverItem',
      'click .js-select-card': 'selectCard',
      'click .js-select-board': 'selectBoard',
      keydown: 'keydownEvent',
      'keyup .js-search': 'keyupEvent',
      'input .js-search': 'updateSearch',
    };
  }

  initialize() {
    this.items = [];
    this.debouncedSearch = this.debounce(this.search, 350).bind(this);
    return this.search('');
  }

  render() {
    const data = {};

    if (!this.model.canAttach()) {
      if (this.model.isOverLimit('attachments', 'perCard')) {
        this.$el.html(limitExceededTemplate('perCard'));
      } else if (this.model.getBoard().isOverLimit('attachments', 'perBoard')) {
        this.$el.html(limitExceededTemplate('perBoard'));
      }
      return this;
    }

    this.$el.html(template(data));

    Promise.resolve(this._lastRenderPromise)
      .then(() => {
        return this.renderItems();
      })
      .done();

    return this;
  }

  renderItems() {
    let data, board;
    $('.js-loading', this.$el).addClass('hide');

    const hiddenCards = new Set([this.model.get('shortLink')]);
    const hiddenBoards = new Set();

    this.model.attachmentList.forEach(function (attachment) {
      const url = attachment.get('url');
      const { type, shortLink } = parseTrelloUrl(url);
      switch (type) {
        case 'card':
          return hiddenCards.add(shortLink);
        case 'board':
          return hiddenBoards.add(shortLink);
        default:
      }
    });

    const cards = this.items.filter(
      (item) => item instanceof Card && !hiddenCards.has(item.get('shortLink')),
    );
    const boards = this.items.filter(
      (item) =>
        item instanceof Board && !hiddenBoards.has(item.get('shortLink')),
    );

    // eslint-disable-next-line @trello/enforce-variable-case
    const $cardList = $('.js-card-list', this.$el).empty();
    // eslint-disable-next-line @trello/enforce-variable-case
    const $boardList = $('.js-board-list', this.$el).empty();

    if (cards.length > 0) {
      const cardHtml = (() => {
        const result = [];
        for (const card of Array.from(cards)) {
          data = card.toJSON();
          board = card.getBoard();

          if (board != null) {
            data.boardName = board.get('name');
          }

          result.push(selectCardTemplate(data));
        }
        return result;
      })();

      $cardList.append(cardHtml);
    }

    if (boards.length > 0) {
      const boardHtml = (() => {
        const result1 = [];
        for (board of Array.from(boards)) {
          const org = board.getOrganization();
          data = board.toJSON();

          if (org != null) {
            data.orgName = org.get('displayName');
          }

          result1.push(selectBoardTemplate(data));
        }
        return result1;
      })();

      $boardList.append(boardHtml);
    }

    if (this.items.length > 0) {
      Util.selectMenuItem(this.$el, '.item', this.$el.find('.item').first());
    }

    const hideCardResults = !this._lastQuery && cards.length === 0;
    const hideBoardResults = !this._lastQuery && boards.length === 0;
    $('.js-card-results', this.$el).toggleClass('hide', hideCardResults);
    $('.js-board-results', this.$el).toggleClass('hide', hideBoardResults);
    $('.js-no-card-results', this.$el).toggleClass('hide', cards.length > 0);
    $('.js-no-board-results', this.$el).toggleClass('hide', boards.length > 0);

    return this;
  }

  keyupEvent(e) {
    const key = getKey(e);

    if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList(this.$el, '.item', key);
    }
  }

  updateSearch(e) {
    const query = $('.js-search', this.$el).val();
    return this.debouncedSearch(query);
  }

  keydownEvent(e) {
    let needle;
    if (((needle = getKey(e)), [Key.Enter, Key.Tab].includes(needle))) {
      stopPropagationAndPreventDefault(e);
      // eslint-disable-next-line @trello/enforce-variable-case
      const $item = this.$el
        .find('.item.selected:first')
        .find('.js-select-card,.js-select-board');
      if ($item.length > 0) {
        return $item.click();
      }
    }
  }

  getTextInput() {
    return $(this.options.target);
  }

  _renderSettledItems(query, eventualItems) {
    if (query !== this._lastQuery) {
      return;
    }

    return (this._lastRenderPromise = Promise.resolve(eventualItems)
      .then(function (items) {
        if (_.isArray(items)) {
          return items;
        } else {
          return [items];
        }
      })
      .catch(ApiError, () => [])
      .tap((items) => {
        this.items = items;
        return this.renderItems();
      })
      .finally(() => {
        return (this._lastRenderPromise = null);
      }));
  }

  search(query) {
    if (query === this._lastQuery) {
      return;
    }

    this._lastQuery = query;

    $('.js-card-results', this.$el).addClass('hide');
    $('.js-board-results', this.$el).addClass('hide');
    $('.js-loading', this.$el).removeClass('hide');

    if (query === '') {
      const RECENT_COUNT = 5;

      const idRecentCards = _.chain(Recents.get('card', RECENT_COUNT + 1))
        .without(this.model.id)
        .first(RECENT_COUNT)
        .value();

      const idRecentBoards = _.chain(getRecentBoards().map((board) => board.id))
        .without(this.model.get('idBoard'))
        .first(RECENT_COUNT)
        .value();

      const recentItems = Promise.props({
        recentCards: Promise.map(idRecentCards, (idCard) => {
          return this.modelCache.getOrLoad({
            type: 'Card',
            id: idCard,
            payload: Payloads.cardCompleter,
            loader(id) {
              return ModelLoader.loadCardCompleterData(id);
            },
          });
        }),

        recentBoards: Promise.map(idRecentBoards, (idBoard) => {
          return this.modelCache.getOrLoad({
            type: 'Board',
            id: idBoard,
            payload: Payloads.boardCompleter,
            loader(id) {
              return ModelLoader.loadBoardCompleterData(id);
            },
          });
        }),
      }).then(({ recentCards, recentBoards }) =>
        _.compact([...Array.from(recentCards), ...Array.from(recentBoards)]),
      );

      this._renderSettledItems(query, recentItems);
      return;
    }

    // See if they're just putting in a URL
    const parsedTrello = parseTrelloUrl(query.trim());
    if (parsedTrello.type === 'card') {
      this._renderSettledItems(
        query,
        ModelLoader.loadCardCompleterData(parsedTrello.shortLink),
      );
      return;
    } else if (parsedTrello.type === 'board') {
      this._renderSettledItems(
        query,
        ModelLoader.loadBoardCompleterData(parsedTrello.shortLink),
      );
      return;
    }

    // Search for a card short id
    if (isShortId(query)) {
      const { card } = this.options;
      const board = card != null ? card.getBoard() : undefined;
      if (board != null) {
        let referencedCard;
        if ((referencedCard = board.getCard(query)) != null) {
          this._renderSettledItems(query, referencedCard);
        } else {
          this._renderSettledItems(
            query,
            ModelLoader.loadCardData(query, board.id),
          );
        }
        return;
      }
    }

    // Search for a phrase
    const searchOptions = {
      query,
      board_fields: 'name,idOrganization,url',
      modelTypes: 'cards,boards',
      partial: true,
      card_board: true,
    };

    ModelLoader.loadSearchData(searchOptions).nodeify((err, results) => {
      if (err == null) {
        const cards = _.chain(results.cards)
          .map((card) => {
            return this.modelCache.get('Card', card.id);
          })
          .sortBy((card) => {
            if (card.get('idBoard') === this.model.get('idBoard')) {
              return 0;
            } else {
              return 1;
            }
          })
          .value();

        const boards = _.chain(results.boards)
          .map((board) => {
            return this.modelCache.get('Board', board.id);
          })
          .sortBy((board) => {
            // Why would you attach a card's board to itself?
            if (board.get('id') === this.model.get('idBoard')) {
              return 1;
            } else {
              return 0;
            }
          })
          .value();

        return this._renderSettledItems(query, [
          ...Array.from(cards),
          ...Array.from(boards),
        ]);
      } else {
        this.items = [];
        return this.renderItems();
      }
    });
  }

  hoverItem(e) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $elem = $(e.target).closest('.item');
    return Util.selectMenuItem(this.$el, '.item', $elem);
  }

  selectCard(e) {
    stopPropagationAndPreventDefault(e);
    const idCard = $(e.target, this.$el)
      .closest('.js-select-card')
      .attr('data-id');
    const card = this.modelCache.get('Card', idCard);
    if (card != null) {
      this.insertItem(card);
    }
  }

  selectBoard(e) {
    stopPropagationAndPreventDefault(e);
    const idBoard = $(e.target, this.$el)
      .closest('.js-select-board')
      .attr('data-id');
    const board = this.modelCache.get('Board', idBoard);
    if (board != null) {
      this.insertItem(board);
    }
  }

  insertItem(item) {
    let word;
    if (this.options.onStartUpload) {
      this.options.onStartUpload(item);
      return;
    }

    const url = item.get('url');
    // eslint-disable-next-line @trello/enforce-variable-case
    const $textInput = this.getTextInput();
    const caretPosition = Util.getCaretPosition($textInput);
    if (caretPosition != null) {
      word = {
        start: caretPosition,
        end: caretPosition,
      };
    }

    Util.insertSelection(
      $textInput,
      `${url} `,
      word != null ? word.start : undefined,
      word != null ? word.end : undefined,
    );
    let actionSubject = 'board';
    const containers = {};

    const isCard = item instanceof Card;

    if (isCard) {
      actionSubject = 'card';
      containers.card = {
        id: item.id,
      };
    } else {
      containers.board = {
        id: item.id,
      };
    }

    return Analytics.sendTrackEvent({
      action: 'added',
      actionSubject,
      source: 'trelloAddCardInlineDialog',
      containers,
    });
  }
}

TrelloCompleterView.initClass();
export { TrelloCompleterView };
